import { createReducer } from "@reduxjs/toolkit";
import { Types } from "./Actions";
import INITIAL_STATE from "./InitialState";

export const PrecertificacionReducer = createReducer(
  INITIAL_STATE,
  (builder) => {
    /**
     * Obtener datos de una precertificacion
     */
    builder
      .addCase(Types.GET_PRECERTIFICACION_LOADING, (state) => {
        state.getPrecertificacionLoading = true;
        state.getPrecertificacionError = null;
      })
      .addCase(Types.GET_PRECERTIFICACION_SUCCESS, (state, action) => {
        const { getPrecertificacionData } = action;
        state.getPrecertificacionData = getPrecertificacionData;
        state.getPrecertificacionLoading = false;
        state.getPrecertificacionError = null;
      })
      .addCase(Types.GET_PRECERTIFICACION_FAILURE, (state, action) => {
        const { getPrecertificacionError } = action;
        state.getPrecertificacionData = INITIAL_STATE.getPrecertificacionData;
        state.getPrecertificacionLoading = false;
        state.getPrecertificacionError = getPrecertificacionError;
      });

    /**
     * Consultar lista de precertificaciones
     */
    builder
      .addCase(Types.CONSULTAR_PRECERTIFICACIONES_LOADING, (state) => {
        state.consultarPrecertificacionesLoading = true;
        state.consultarPrecertificacionesError = null;
      })
      .addCase(Types.CONSULTAR_PRECERTIFICACIONES_SUCCESS, (state, action) => {
        const { consultarPrecertificacionesData } = action;
        state.consultarPrecertificacionesData = consultarPrecertificacionesData;
        state.consultarPrecertificacionesLoading = false;
        state.consultarPrecertificacionesError = null;
      })
      .addCase(Types.CONSULTAR_PRECERTIFICACIONES_FAILURE, (state, action) => {
        const { consultarPrecertificacionesError } = action;
        state.consultarPrecertificacionesData =
          INITIAL_STATE.consultarPrecertificacionesData;
        state.consultarPrecertificacionesLoading = false;
        state.consultarPrecertificacionesError =
          consultarPrecertificacionesError;
      });

    /**
     * Confirmar una precertificacion
     */
    builder
      .addCase(Types.CONFIRMAR_PRECERTIFICACION_LOADING, (state) => {
        state.confirmarPrecertificacionLoading = true;
        state.confirmarPrecertificacionError = null;
      })
      .addCase(Types.CONFIRMAR_PRECERTIFICACION_SUCCESS, (state, action) => {
        const { confirmarPrecertificacionData } = action;
        state.confirmarPrecertificacionData = confirmarPrecertificacionData;
        state.confirmarPrecertificacionLoading = false;
        state.confirmarPrecertificacionError = null;
      })
      .addCase(Types.CONFIRMAR_PRECERTIFICACION_FAILURE, (state, action) => {
        const { confirmarPrecertificacionError } = action;
        state.confirmarPrecertificacionData =
          INITIAL_STATE.confirmarPrecertificacionData;
        state.confirmarPrecertificacionLoading = false;
        state.confirmarPrecertificacionError = confirmarPrecertificacionError;
      });

    /**
     * Cancelar una precertificacion
     */
    builder
      .addCase(Types.CANCELAR_PRECERTIFICACION_LOADING, (state) => {
        state.cancelarPrecertificacionLoading = true;
        state.cancelarPrecertificacionError = null;
      })
      .addCase(Types.CANCELAR_PRECERTIFICACION_SUCCESS, (state, action) => {
        const { cancelarPrecertificacionData } = action;
        state.cancelarPrecertificacionData = cancelarPrecertificacionData;
        state.cancelarPrecertificacionLoading = false;
        state.cancelarPrecertificacionError = null;
      })
      .addCase(Types.CANCELAR_PRECERTIFICACION_FAILURE, (state, action) => {
        const { cancelarPrecertificacionError } = action;
        state.cancelarPrecertificacionData =
          INITIAL_STATE.cancelarPrecertificacionData;
        state.cancelarPrecertificacionLoading = false;
        state.cancelarPrecertificacionError = cancelarPrecertificacionError;
      });

    /**
     * Tipos solicitudes precertificacion
     */
    builder
      .addCase(Types.TIPOS_SOLICITUDES_PRECERTIFICACION_LOADING, (state) => {
        state.tiposSolicitudesPrecertificacionLoading = true;
        state.tiposSolicitudesPrecertificacionError = null;
      })
      .addCase(
        Types.TIPOS_SOLICITUDES_PRECERTIFICACION_SUCCESS,
        (state, action) => {
          const { tiposSolicitudesPrecertificacionData } = action;
          state.tiposSolicitudesPrecertificacionData =
            tiposSolicitudesPrecertificacionData;
          state.tiposSolicitudesPrecertificacionLoading = false;
          state.tiposSolicitudesPrecertificacionError = null;
        }
      )
      .addCase(
        Types.TIPOS_SOLICITUDES_PRECERTIFICACION_ERROR,
        (state, action) => {
          const { tiposSolicitudesPrecertificacionError } = action;
          state.tiposSolicitudesPrecertificacionData =
            INITIAL_STATE.tiposSolicitudesPrecertificacionData;
          state.tiposSolicitudesPrecertificacionLoading = false;
          state.tiposSolicitudesPrecertificacionError =
            tiposSolicitudesPrecertificacionError;
        }
      );

    /**
     * crear precertificacion
     */
    builder
      .addCase(Types.CREAR_PRECERTIFICACION_LOADING, (state) => {
        state.crearPrecertificacionLoading = true;
        state.crearPrecertificacionError = null;
      })
      .addCase(Types.CREAR_PRECERTIFICACION_SUCCESS, (state, action) => {
        const { crearPrecertificacionData } = action;
        state.crearPrecertificacionData = crearPrecertificacionData;
        state.crearPrecertificacionLoading = false;
        state.crearPrecertificacionError = null;
      })
      .addCase(Types.CREAR_PRECERTIFICACION_ERROR, (state, action) => {
        const { crearPrecertificacionError } = action;
        state.crearPrecertificacionData =
          INITIAL_STATE.crearPrecertificacionData;
        state.crearPrecertificacionLoading = false;
        state.crearPrecertificacionError = crearPrecertificacionError;
      });

    /**
     * Consultar una precertificacion
     */
    builder
      .addCase(Types.CONSULTAR_UNA_PRECERTIFICACION_LOADING, (state) => {
        state.consultarUnaPrecertificacionLoading = true;
        state.consultarUnaPrecertificacionError = null;
      })
      .addCase(
        Types.CONSULTAR_UNA_PRECERTIFICACION_SUCCESS,
        (state, action) => {
          const { consultarUnaPrecertificacionData } = action;
          state.consultarUnaPrecertificacionData =
            consultarUnaPrecertificacionData;
          state.consultarUnaPrecertificacionLoading = false;
          state.consultarUnaPrecertificacionError = null;
        }
      )
      .addCase(
        Types.CONSULTAR_UNA_PRECERTIFICACION_FAILURE,
        (state, action) => {
          const { consultarUnaPrecertificacionError } = action;
          state.consultarUnaPrecertificacionData =
            INITIAL_STATE.consultarUnaPrecertificacionData;
          state.consultarUnaPrecertificacionLoading = false;
          state.consultarUnaPrecertificacionError =
            consultarUnaPrecertificacionError;
        }
      );

    /**
     * modificar precertificacion
     */
    builder
      .addCase(Types.MODIFICAR_PRECERTIFICACION_LOADING, (state) => {
        state.modificarPrecertificacionLoading = true;
        state.modificarPrecertificacionError = null;
      })
      .addCase(Types.MODIFICAR_PRECERTIFICACION_SUCCESS, (state, action) => {
        const { modificarPrecertificacionData } = action;
        state.modificarPrecertificacionData = modificarPrecertificacionData;
        state.modificarPrecertificacionLoading = false;
        state.modificarPrecertificacionError = null;
      })
      .addCase(Types.MODIFICAR_PRECERTIFICACION_ERROR, (state, action) => {
        const { modificarPrecertificacionError } = action;
        state.modificarPrecertificacionData =
          INITIAL_STATE.modificarPrecertificacionData;
        state.modificarPrecertificacionLoading = false;
        state.modificarPrecertificacionError = modificarPrecertificacionError;
      });

    /**
     * descargar voucher precertificacion
     */
    builder
      .addCase(Types.DESCARGAR_VOUCHER_PRECERTIFICACION_LOADING, (state) => {
        state.descargarVoucherPrecertificacionLoading = true;
        state.descargarVoucherPrecertificacionError = null;
      })
      .addCase(
        Types.DESCARGAR_VOUCHER_PRECERTIFICACION_SUCCESS,
        (state, action) => {
          const { descargarVoucherPrecertificacionData } = action;
          state.descargarVoucherPrecertificacionData =
            descargarVoucherPrecertificacionData;
          state.descargarVoucherPrecertificacionLoading = false;
          state.descargarVoucherPrecertificacionError = null;
        }
      )
      .addCase(
        Types.DESCARGAR_VOUCHER_PRECERTIFICACION_ERROR,
        (state, action) => {
          const { descargarVoucherPrecertificacionError } = action;
          state.descargarVoucherPrecertificacionData =
            INITIAL_STATE.descargarVoucherPrecertificacionData;
          state.descargarVoucherPrecertificacionLoading = false;
          state.descargarVoucherPrecertificacionError =
            descargarVoucherPrecertificacionError;
        }
      );
  }
);
